import { useState, useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { useTracking } from "react-tracking";
import { apiApplyDiscount, apiDeleteDiscount } from "Root/api/apiRecharge";
import { setDiscount, setSubscriptionStoreAction, } from "Root/profile/redux/actionCreators/makeActionCreator";
import { BuyNowThunk } from "Root/profile/redux/thunkCreators/getItNow/getItNowThunk";
import { useAppStore } from "Root/profile/lib/store";
const useYourSubscriptionV2 = () => {
    const isByb = useSelector((state) => state.user.user_class === "byb");
    const reduxUserCart = useSelector((state) => state.userCart);
    const pricing = useSelector((state) => state.pricing);
    const pricingSummary = useSelector((state) => state.pricing.lineItems);
    const hasSubscription = useSelector((state) => state.user.has_subscription);
    const location = useLocation();
    const { state } = location;
    const availablePointBalance = useSelector((state) => state.accountSettings.userAccount.availablePointBalance);
    const userAccount = useSelector((state) => state.accountSettings.userAccount);
    const pointsLoaded = useSelector((state) => state.accountSettings.userAccount.pointsLoaded);
    const discountStr = pricing.discount_str;
    const { referral_data } = pricing;
    const ordersDates = useSelector((state) => state.ordersInfo.nextOrderDates);
    const originalUserCart = useSelector((state) => state.originalUserCart);
    const [reactivate, setReactivate] = useState(false);
    const history = useHistory();
    const [openDrawer, setOpenDrawer] = useState(false);
    const toggleReactivate = (value) => () => {
        setReactivate(value);
    };
    const dispatch = useDispatch();
    const { fetchRechargeUpcomingOrder } = useAppStore();
    const goBack = () => {
        if (state?.prevPath) {
            history.push(state.prevPath);
        }
        else {
            history.push("/app/subscription");
        }
    };
    const getTotalPrice = () => pricing.lineItems.find((item) => item.line_item_name === "This shipment")?.line_item_price;
    const { trackEvent } = useTracking();
    const applyPromo = useCallback(async (promo) => {
        const response = await apiApplyDiscount({ discount_code: promo });
        await fetchRechargeUpcomingOrder();
    }, []);
    const setDiscountString = (value) => {
        if (value !== null) {
            dispatch(setDiscount(value));
        }
    };
    const removePromo = useCallback(async (promo) => {
        const response = await apiDeleteDiscount();
        await fetchRechargeUpcomingOrder();
    }, []);
    const toggleDrawer = (value) => () => {
        setOpenDrawer(value);
    };
    const userInfo = useSelector((state) => state.generalUserInfo);
    const totalItemsInCart = originalUserCart.reduce((prev, curr) => prev + Number(curr.quantity), 0);
    const { plan } = useSelector((state) => state.ordersInfo.nextOrderDates);
    const [currentChosenCadence, setCurrentChosenCadence] = useState(ordersDates.planCadence);
    const cadenceStr = `${ordersDates.planCadence} ${ordersDates.planCadenceType}`;
    const [shouldPresetPlan, setShouldPresetPlan] = useState(false);
    const [isPlanSelectOpen, setIsPlanSelectOpen] = useState(false);
    const [currentPlan, setCurrentPlan] = useState("standard");
    const [isDeliveryOpen, setIsDeliveryOpen] = useState(false);
    const showBanner = useSelector((state) => state.banner);
    const payNow = () => {
        dispatch(setSubscriptionStoreAction(true));
        dispatch(BuyNowThunk(history, true, undefined));
    };
    useEffect(() => {
        const product = history.location.hash.replace("#", "");
        if (product === "rewards") {
            const dropdown = document.getElementById("rewards_dropdown");
            if (dropdown) {
                dropdown.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
    }, [availablePointBalance]);
    return {
        showBanner,
        isDeliveryOpen,
        setIsDeliveryOpen,
        currentPlan,
        setCurrentPlan,
        isPlanSelectOpen,
        setIsPlanSelectOpen,
        shouldPresetPlan,
        setShouldPresetPlan,
        currentChosenCadence,
        setCurrentChosenCadence,
        plan,
        totalItemsInCart,
        userInfo,
        toggleDrawer,
        reduxUserCart: reduxUserCart.map((item) => ({
            ...item,
            title: isByb ? item.title.replace("Personalized", "").replace("Performance Boost", "") : item.title,
        })),
        pricing,
        hasSubscription,
        pricingSummary,
        discountStr,
        openDrawer,
        applyPromo,
        getTotalPrice,
        setDiscountString,
        ordersDates,
        cadenceStr,
        removePromo,
        toggleReactivate,
        reactivate,
        payNow,
        availablePointBalance,
        pointsLoaded,
        goBack,
        isByb,
        referral_data,
    };
};
export default useYourSubscriptionV2;
